import { useSelector } from 'react-redux';
import { Company } from '../../../models/company';
import { RootState } from '../../../reducers';

function assertCompanyIsDefined(company: Company | undefined) {
  if (!company) {
    throw new Error(`'RootState' has an undefined 'userInfo.company' configured, expected a company-defined state`);
  }
}

export function useCompany(): Company {
  const company = useSelector((state: RootState) => state.userInfo.company);

  assertCompanyIsDefined(company);

  return company!;
}
